// @ts-check

import React, { Component } from "react"
import { Link } from "react-router"
import { multiline, text } from "../../attributes/items/primitives"
import { Text } from "ui"
import ContentEditable from "react-sane-contenteditable"
import { Helmet } from "react-helmet"

/**
 * @augments {Component<BlockTypeProps<{text: string}>, any>}
 */
export default class HTMLBlockType extends Component {
    componentDidMount() {
        if (this.props.config.attributes["script"]) {
            const script = document.createElement("script")
            script.async = true
            script.text = this.props.config.attributes["script"]
            document.body.appendChild(script)
        }
    }
    render() {
        const Wrapper = this.props.Wrapper
        return (
            <Wrapper {...this.props}>
                {({ attrs, computedStyle }) => {
                    // return <Helmet dangerouslySetInnerHTML={{ __html: attrs.html }} />
                    return (
                        <Helmet>
                            {attrs.title && <title>{attrs.title}</title>}
                            {attrs.og_title && (
                                <meta property="og:title" content={attrs.og_title} />
                            )}
                            {attrs.og_description && (
                                <meta property="og:description" content={attrs.og_description} />
                            )}
                            {attrs.og_image && (
                                <meta property="og:image" content={attrs.og_image} />
                            )}
                            {attrs.og_url && <meta property="og:url" content={attrs.og_url} />}
                        </Helmet>
                    )
                }}
            </Wrapper>
        )
    }
}

HTMLBlockType.attributes = [
    text({ field: "title", label: "Page title" }),
    text({ field: "og_title", label: "Open Graph title" }),
    text({ field: "og_description", label: "Open Graph description" }),
    text({ field: "og_image", label: "Open Graph image" }),
    text({ field: "og_url", label: "Open Graph url" }),
    //multiline({ field: "html", label: "MetaTags HTML" }),
]



// WEBPACK FOOTER //
// ./src/features/editor/blockTypes/other/MetaTagsBlock.js